export default "__VITE_ASSET__foMO2bXO__"